const authProps = {
  props: true,
  meta: {
    auth: true,
    ph: true,
  }
};

export default [
  {
    path: '/register',
    name: 'Register',
    component: () => import(/* webpackChunkName: "v2-register" */ '@app2/modules/Register/Pages/Index'),
    ...authProps,
    redirect: '/register/form',
    children: [
      {
        path: '/register/form',
        name: 'RegisterForm',
        component: () => import(/* webpackChunkName: "v2-register" */ '@app2/modules/Register/components/Form'),
        ...authProps
      },
      {
        path: '/register/email',
        redirect: '/register/form'
      },
      // {
      //   path: '/register/plan',
      //   name: 'OnboardingPlan',
      //   component: () => import(/* webpackChunkName: "v2-register" */ '@app2/modules/Register/components/Plan'),
      //   ...authProps
      // },
      // {
      //   path: '/register/details',
      //   name: 'OnboardingDetails',
      //   component: () => import(/* webpackChunkName: "v2-register" */ '@app2/modules/Register/components/Details'),
      //   ...authProps
      // },
      // {
      //   path: '/register/migration',
      //   name: 'OnboardingMigration',
      //   component: () => import(/* webpackChunkName: "v2-register" */ '@app2/modules/Register/components/Migration'),
      //   ...authProps
      // },
      {
        path: '/register/single-step',
        name: 'OnboardingSingleStep',
        component: () => import(/* webpackChunkName: "v2-register" */ '@app2/modules/Register/components/Form'),
        ...authProps,
      },
      {
        path: '/register/create',
        name: 'OnboardingCreate',
        component: () => import(/* webpackChunkName: "v2-register" */ '@app2/modules/Register/components/Create'),
        ...authProps
      },
      {
        path: '/register/building',
        name: 'OnboardingBuilding',
        component: () => import(/* webpackChunkName: "v2-register" */ '@app2/modules/Register/components/Building'),
        meta: {
          auth: true,
          ph: true,
        }
      },
      {
        path: '/register/verify-otp',
        name: 'VerifyOtp',
        component: () => import(/* webpackChunkName: "v2-register" */ '@app2/modules/Register/components/VerifyOtp'),
        meta: {
          auth: true,
          ph: true,
        }
      },
    ]
  },
]